import { isInWix } from './is-in-wix';

const wixInstanceId = '33750584-5cda-44e1-8738-62a9139347b3';

const WixPolyfill = {
  addEventListener: () => {},
  isApplicationInstalled: (appId, cb) => cb(false),
  removeEventListener: () => {},
  currentMember: cb => cb(null),
  requestLogin: () => {},
  logOutCurrentMember: () => {},
  replaceSectionState: () => {},
  closeWindow: () => {},
  setHeight: () => {},
  resizeComponent: () => {},
  WindowOrigin: {},
  WindowPlacement: {},
  getCurrentPageId: cb => cb('pageId'),
  getSitePages: () => [{ id: '/' }],
  getSiteInfo: () => {},
  navigateToPage: () => {},
  scrollTo: () => {},
  setPageMetadata: () => {},
  getSiteMap: cb => cb([]),
  getPublicAPI: () => {},
  getSiteTextPresets: () => {},
  Events: {},
  PubSub: {
    publish: () => {},
    subscribe: () => {},
  },
  openPopup: () => {},
  Utils: {
    getUid: () => '00000000-0000-0000-0000-000000000001',
    getSectionUrl: () => `${window.location.protocol}//${window.location.host}/`,
    getInstanceId: () => wixInstanceId,
    getInstanceValue: () => '00000000-0000-0000-0000-000000000000',
    getViewMode: () => '',
    navigateToSection: () => {},
  },
  Performance: {
    applicationLoaded: () => {},
    applicationLoadingStep: () => {},
  },
  Theme: {
    BARE: 0,
  },
  Styles: {
    getSiteTextPresets: () => {},
  },
};

export const instanceId = wixInstanceId;

export default (typeof window !== 'undefined' ? (isInWix() ? window.Wix || WixPolyfill : WixPolyfill) : WixPolyfill);



// WEBPACK FOOTER //
// ./app/services/wix-sdk-polyfill.js